import { useStore } from "@/stores/store-context";

/**
 * Read a LaunchDarkly boolean flag from the feature-flag store.
 *
 * Centralises the `isReady` guard so callers don't re-implement it: until the
 * LD client has fired `ready` (and whenever LD is disabled in local/CI, or the
 * key is absent) the flag reads as `fallback`. Must be called from inside an
 * `observer` component — it reads observable store state, so the component
 * re-renders when the flag value changes (LD `change` event).
 */
export function useFeatureFlag(key: string, fallback = false): boolean {
  const { featureFlags } = useStore();
  return featureFlags.isReady ? featureFlags.isEnabled(key, fallback) : fallback;
}
